export default function getHubItemUri(item) {
  return item?.events?.click?.name === 'navigate' || item?.target?.uri
    ? item?.events?.click?.data?.uri || item?.target?.uri
    : null;
}
